import { render, staticRenderFns } from "./v80w1010 copy 1.vue?vue&type=template&id=234be3cd&"
import script from "./v80w1010 copy 1.vue?vue&type=script&lang=js&"
export * from "./v80w1010 copy 1.vue?vue&type=script&lang=js&"
import style0 from "./v80w1010 copy 1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports